<template>
    <div class="accountcash">
         <PageTitle 
            icon="fa fa-clone" 
            main="Registro" 
            sub="Conta Caixa" />
         <b-form  
            v-show="mode === 'save' || mode === 'remove' || mode === 'read'">
             <input 
                id="accountcash-id" 
                type="hidden" 
                v-model="entity.id" />
             <b-row>
                <b-col 
                    md="4" 
                    sm="12">
                    <b-form-group 
                        label="Nome:" 
                        label-for="accountcash-name">
                        <b-form-input 
                            id="accountcash-name" 
                            type="text" 
                            ref="searchFocus"
                            v-model="entity.name_entity" 
                            required
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Nome do Caixa..." />
                    </b-form-group>
                </b-col>
                 <b-col 
                    md="3" 
                    sm="12">
                    <b-form-group 
                        label="Ref. Caixa" 
                        label-for="accountcash-cnpj_cpf">    
                        <b-form-input 
                            id="accountcash-cnpj_cpf" 
                            type="text"
                            v-model="entity.cnpj_cpf" 
                            required
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="CX000..." />
                    </b-form-group>
                </b-col>
                 <b-col 
                    md="1" 
                    sm="12">
                    <div 
                        class="form-group">
                        <div 
                            class="form-check">
                            <input 
                                class="form-check-input" 
                                v-model="entity.blocked" 
                                true-value="1" 
                                false-value="0" 
                                type="checkbox" 
                                id="accountcash-blocked"
                                :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label 
                                class="form-check-label" 
                                for="accountcash-blocked">
                                Bloqueado?
                            </label>
                        </div>
                    </div>
                </b-col>  
             </b-row>
            <b-row>
                <b-col 
                    md="4"
                    sm="12">
                    <b-form-group 
                        label="Empresa:" 
                        label-for="accountcash-company_id">
                        <b-form-select 
                            id="accountcash-company_id"
                            size="sm"
                            :options="companys" 
                            v-model="entity.company_id" />
                    </b-form-group>
                </b-col>
            </b-row>
         </b-form>
        <hr v-show="mode === 'save'">
              <b-row>
                <b-col xs="12" class="sub-background">
                   <b-button  
                        size="sm" 
                        variant="light" 
                        class="mt-2  mb-2 fa fa-plus" 
                        v-show="mode !== 'save' && mode !== 'remove'"
                        @click="alterModo">
                    </b-button>
                    <b-button 
                         
                        size="sm" 
                        variant="light"
                        class="mt-2 mb-2 ml-2 fa fa-save" 
                        v-if="mode === 'save'"
                        @click="save">
                        </b-button>
                    <b-button 
                         
                        size="sm" 
                        variant="light" 
                        class="mt-2 mb-2 ml-2 fa fa-trash" 
                        v-if="mode === 'remove'"
                        @click="remove">
                        </b-button>
                    <b-button 
                        size="sm" 
                        btn-sm 
                        variant="light" 
                        class="mt-2 mb-2 ml-2 fa fa-ban"  
                        v-if="mode === 'remove' || mode === 'save' || mode === 'read' "
                        @click="reset">
                    </b-button>
                    <b-button 
                         size="sm" 
                         class="mt-2 mb-2 ml-2 fa" 
                         :class="icon" 
                         @click="[loadAccountCashs(),toggleBusy(),showTable = !showTable]" 
                         variant="light" >
                    </b-button>
                </b-col>
            </b-row>
            <br>
           <div class="col-sm-4">
                    <div class="form-group">
                        <input 
                            type="text" 
                            size="sm" 
                            icon="search" 
                            v-model="search" 
                            ref="searchFocus"
                              v-show="mode !== 'save' && mode !== 'remove'"
                            placeholder="Informe a descrição" 
                            class="form-control">
                    </div>
                </div>
           <transition  
            name="slide" 
            type="animation" 
            appear>          
            <b-table 
                 :busy="isBusy"  
                class="table-responsive" 
                v-show="showTable" 
                hover key="slide" 
                 head-variant="light" 
                :items="filteredList" 
                :fields="fields">
            <template v-slot:table-busy>
                <div class="text-center text-info my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Carregando...</strong>
                </div>
            </template>
            <template v-slot:cell(actions)="data">
                        <b-button 
                             size="sm" 
                            variant="light" 
                            @click="loadAccountCash(data.item)" 
                            class="mr-2 mt-2">
                        <i class="fa fa-pencil"></i>
                        </b-button>
                        <b-button 
                             size="sm" 
                            variant="light" 
                            @click="loadAccountCash(data.item, 'remove')"
                            class="mr-2 mt-2">
                        <i class="fa fa-trash"></i>
                        </b-button>
                    </template>   
            </b-table>    
           </transition>
            <transition  name="slide" type="animation" appear>
            <b-pagination
                v-show="showTable"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                size="sm"
                aria-controls="my-table"
            ></b-pagination>
          </transition> 
    </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'

export default {
    name: 'AccountCash',
    components: {PageTitle},
    data: function() {
        return {
            mode: 'insert',
            search: '',
            entity: {},
            entitys: [],
            companys:[],
            showTable: false,
            isBusy: false,
            currentPage: 1,
            perPage: 5,
            fields: [
                { key: 'name_entity', label: 'Nome', sortable: true },
                { key: 'cnpj_cpf', label: 'Ref. Caixa', sortable: false },
                { key: 'blocked', label: 'Bloqueado', sortable: false,
                        formatter: value => value ? 'Sim' : 'Não' },
                { key: 'actions', label: 'Ações',variant: 'light' }
            ]
        }
    },
     computed: {
        user(){
            return this.$store.state.user
        },
        filteredList() {
        return this.entitys.filter(entity => {
        return entity.name_entity.toLowerCase().includes(this.search.toLowerCase())
            })
        },
         icon() {
            return this.showTable ? "fa-retweet" : "fa-search"
        },
         rows() {
            return this.entitys.length
        }
    },
    methods: {
        loadAccountCashs() {
            const url = `${baseApiUrl}/entitystypeentitys/2`
            axios.get(url).then(res => {
                this.entitys = res.data
                this.isBusy = false
            })
        },
        reset() {
            this.mode = 'insert'
            this.loadAccountCashs()
        },
        toggleBusy() {
            this.isBusy = !this.isBusy
        },
        alterModo() {
                    this.mode = 'save'
                    this.entity = {}
                    this.$refs.searchFocus.focus();
            },
        save() {
            this.entity.type_entity_id = 2
            this.entity.user_id = this.user.id
            const method = this.entity.id ? 'put' : 'post'
            const id = this.entity.id ? `/${this.entity.id}` : ''
            axios[method](`${baseApiUrl}/entitys${id}`, this.entity)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        remove() {
            const id = this.entity.id
            axios.delete(`${baseApiUrl}/entitys/${id}`)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        loadAccountCash(entity, mode = 'save') {
            this.mode = mode
            this.entity = { ...entity }
            this.$refs.searchFocus.focus();
        },
        loadCompanys() {
                    const url = `${baseApiUrl}/companys`
                    axios.get(url).then(res => {
                        this.companys = res.data.map(company => {
                            return { value: company.id, text: company.name_company }
                        })
                    })
                },
    },
    mounted() {
       this.loadCompanys()
       this.loadAccountCashs()
       this.showTable = true
    }
}
</script>

<style>

    .sub-background{
      background:linear-gradient(to top, #bdc3c7, #e7ebee);
      border-radius: 35px ;
    }

    .accountcash select{
        font-size: 0.7rem;
    }
    .accountcash input{
        font-size: 0.7rem;
    }
    .accountcash button{
        font-size: 0.7rem;
    }

     .accountcash table{
        font-size: 0.7rem;
    }

    
    @keyframes slide-in {
    from {transform: translateY(40px);}
    to {transform: translateY(0);}
    }

    @keyframes slide-out {
        from {transform: translateY(0);}
        to {transform: translateY(40px);}
    }

    .slide-enter-active {
    animation: slide-in 1s ease;
        transition: opacity 1s;
    }

    .slide-leave-active {
        animation: slide-out 1s ease;
        transition: opacity 1s;
    }

    .slide-enter, .slide-leave-to{
        opacity: 0;
    }

    .fade-enter, .fade-leave-to{
    opacity: 0;
    }

    .fade-enter-active, .fade-leave-active{
    transition: opacity 1s;
}

</style>
